export const HEADER_CONST = {
    clickTypeTargetLogo: "Logo",
    clickTypeTargetLogout: "Log Out",
    clickTrackSection: "Header",
    linkTypeIcon: "Icon",
    linkType: "CTA"
}